import { siGmail, siHubspot, siN8n } from "simple-icons";

const icons: Record<string, { path: string; hex: string; title: string }> = {
  Gmail: siGmail,
  HUBSPOT: siHubspot,
  HubSpot: siHubspot,
  N8N: siN8n,
  n8n: siN8n,
};

const pdfBrandAssets: Record<string, { src: string; label: string; className: string }> = {
  GOOGLE_WORKSPACE: {
    src: "/brand/providers/google-workspace-from-mvp.png",
    label: "Google Workspace",
    className: "brand-icon-google",
  },
  "GOOGLE WORKSPACE": {
    src: "/brand/providers/google-workspace-from-mvp.png",
    label: "Google Workspace",
    className: "brand-icon-google",
  },
  HERMES: {
    src: "/brand/providers/hermes-from-mvp.png",
    label: "Hermes",
    className: "brand-icon-hermes",
  },
  HERMES_AI: {
    src: "/brand/providers/hermes-from-mvp.png",
    label: "Hermes",
    className: "brand-icon-hermes",
  },
  HUNTER: {
    src: "/brand/providers/hunter-from-mvp.png",
    label: "Hunter",
    className: "brand-icon-hunter",
  },
};

export function BrandIcon({ name }: { name: string }) {
  const normalized = name.toUpperCase();
  const pdfAsset = pdfBrandAssets[normalized];
  if (pdfAsset)
    return (
      <span
        className={`brand-icon brand-icon-image ${pdfAsset.className}`}
        role="img"
        aria-label={pdfAsset.label}
        title={pdfAsset.label}
      >
        <img src={pdfAsset.src} alt="" aria-hidden="true" />
      </span>
    );
  if (name === "TWILIO_WHATSAPP" || name === "Twilio WhatsApp")
    return (
      <span className="brand-icon" title="Twilio" style={{ color: "#F22F46" }}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle
            cx="12"
            cy="12"
            r="9.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.3"
          />
          <circle cx="8.7" cy="8.7" r="2.15" fill="currentColor" />
          <circle cx="15.3" cy="8.7" r="2.15" fill="currentColor" />
          <circle cx="8.7" cy="15.3" r="2.15" fill="currentColor" />
          <circle cx="15.3" cy="15.3" r="2.15" fill="currentColor" />
        </svg>
      </span>
    );
  const icon = icons[name];
  if (!icon) return <span className="brand-fallback">{name.slice(0, 1)}</span>;
  return (
    <span
      className="brand-icon"
      title={icon.title}
      style={{ color: `#${icon.hex}` }}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d={icon.path} />
      </svg>
    </span>
  );
}
